// extracted by css-extract-rspack-plugin
export default {"menuRow":"menuRow-gJELPT","menuRowActive":"menuRowActive-E9IlLN","menuRowHoverable":"menuRowHoverable-tKtgL5","menuLink":"menuLink-RfURAE"};